import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useShallowEqualSelector } from 'util/hooks';
import { FullState } from 'main/reducers';
import { useDispatch } from 'react-redux';
import { clearBulkCreateErrors } from 'ducks/bulk-create/errors';
import { AlarmParameterBulkCreateErrorsView } from './AlarmParameterBulkCreateErrorsView';

export const AlarmParameterBulkCreateErrorsScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const state = useShallowEqualSelector((state: FullState) => {
    return {
      errorDetail: state.bulkCreateErrors.errorDetail,
    };
  });

  const handleCancel = useCallback(() => {
    history.push('/alarm-parameter-report/');
  }, [history]);

  useEffect(() => {
    return () => {
      dispatch(clearBulkCreateErrors());
    };
  }, [dispatch]);

  return (
    <AlarmParameterBulkCreateErrorsView
      errorDetail={state.errorDetail}
      handleCancel={handleCancel}
    />
  );
};
